import { default as index9xeP2sz8ZcMeta } from "/opt/buildhome/repo/app/pages/index.vue?macro=true";
import { default as not_45supportedVlgnVzpP93Meta } from "/opt/buildhome/repo/node_modules/.c12/github_onderwijsin_onderwijsloket_sJh5Cv9YiK/pages/not-supported.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index9xeP2sz8ZcMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  },
  {
    name: "not-supported",
    path: "/not-supported",
    meta: not_45supportedVlgnVzpP93Meta || {},
    component: () => import("/opt/buildhome/repo/node_modules/.c12/github_onderwijsin_onderwijsloket_sJh5Cv9YiK/pages/not-supported.vue")
  }
]